import React from 'react';
import { Search } from 'lucide-react';
import { useI18n } from '../i18n/index.jsx';

// `widgetItem` arrives pre-translated from the widget (t('items_sessions') etc.)
const NoResults = ({ widgetItem, searchQuery, hasActiveFiltersOrSearch, handleClearFilters }) => {
  const { t } = useI18n();
  const items = widgetItem || t('items_results');
  return (
    <div className="no-results">
      <div className="no-results__content">
        <Search size={48} />
        <div className="no-results__title">{t('no_items_found', { items })}</div>
        <div className="no-results__description">
          {searchQuery ? t('no_results_for', { query: searchQuery }) : t('try_adjusting_filters')}
        </div>
        {hasActiveFiltersOrSearch && (
          <button className="no-results__button" onClick={handleClearFilters}>
            {t('clear_all_filters')}
          </button>
        )}
      </div>
    </div>
  );
};

export default NoResults;
